<script>

    import Menu from '../$layouts/menu.layout.svelte'
    import Container from '../$layouts/container.layout.svelte'

    import Tabs from '../$components/tabs.svelte'

    import PickupsView from '../pickups/view.pickups.svelte'
    import AccountsView from '../accounts/view.accounts.svelte'
    import TicketsView from '../tickets/view.tickets.svelte'
    import ChargesView from '../charges/view.charges.svelte'
    import CoverageView from '../quotations/view.coverage.svelte'

    let selected = 'coverage'

    const tabsOptions = [
        {key: 'coverage', name: 'Cobertura', icon: 'map-marker-alt'},
        {key: 'accounts', name: 'Cuenta consumo', icon: 'file-invoice-dollar'},
        {key: 'charges', name: 'Cargos y reemblosos', icon: 'money-check-alt'},
        {key: 'pickups', name: 'Recolecciones', icon: 'people-carry'},
        {key: 'tickets', name: 'Tickets', icon: 'ticket-alt'},
    ]

</script>

<Menu />

<Container>

    <Tabs bind:selected={selected} options={tabsOptions} />

    {#if selected === 'pickups'}
        <PickupsView />
    {:else if selected === 'accounts'}
        <AccountsView />
    {:else if selected === 'charges'}
        <ChargesView />
    {:else if selected === 'tickets'}
        <TicketsView />
    {:else if selected === 'coverage'}
        <CoverageView />
    {/if}

</Container>